import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { AuthService } from '../../services/auth.service';
import { AccessManagerService } from '../../services/access.manager.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

  public menuItems: Menu[] | any;
  public url: any;
  public fileurl: any;
  userDetail:any = null;
  profileimagePath:string = 'assets/images/user/1.jpg'
  isManagerDashbaordEnabled:boolean = false
  roleDetails:any = null;

  constructor(private router: Router, public navServices: NavService,private accessService:AccessManagerService,private authService:AuthService) {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems
      this.applyAccessControl();
      console.log(this.menuItems);
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url)
              this.setNavActive(items)
            if (!items.children) return false
            items.children.filter(subItems => {
              if (subItems.path === event.url)
                this.setNavActive(subItems)
              if (!subItems.children) return false
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url)
                  this.setNavActive(subSubItems)
              })
              return
            })
            return
          }
          )
        }
      })
    })
  }
  ngOnInit(): void {
    this.loadUserInfo();
    //this.roleDetails = this.accessService.getUserRoles();
    this.applyAccessControl();
  }

    private loadUserInfo(){
    this.userDetail = this.authService.getCurrentUser();
    console.log('-----------')
    console.log(this.userDetail);
    console.log('-----------')

  }


  private getUserDetails(){
    const user =  this.authService.getCurrentUser();
    this.profileimagePath = `assets/images/profile/200/${user?.userName}.jpg`
    this.isManagerDashbaordEnabled = user?.userName === 'sameer' ||
    user?.userName === 'manisha'
  }

  private applyAccessControl() {
  const currentUser = this.authService.getCurrentUser();

  this.profileimagePath = currentUser.profilePicture;
    this.isManagerDashbaordEnabled = currentUser?.userName === 'Sameer' ||
    currentUser?.userName === 'Manisha'

  if (!currentUser?.access || !this.menuItems) return;

  const accessList = currentUser.access;

  // Loop through main menus
  this.menuItems.forEach((menu: any) => {

    // Main menu access
    const moduleAccess = accessList.find(x => x.moduleName === menu.title);
    menu.hasAccess = !!moduleAccess;

    // If main module not accessible → set children false
    if (!moduleAccess) {
      if (menu.children) {
        menu.children.forEach((child: any) => child.hasAccess = false);
      }
      return;
    }

    // Sub menu access from ModuleElements
    const allowedSubMenus = moduleAccess.moduleElements || [];
    console.log(allowedSubMenus);
    // Set access for submenu elements
    if (menu.children) {
      menu.children.forEach((child: any) => {
        child.hasAccess = allowedSubMenus.includes(child.title);
        console.log(child);
      });
    }
  });

  console.log("Final Menu After Access Applied:", this.menuItems);
}



  // Active Nave state
  setNavActive(clickedItem: any) {

  const currentUser = this.authService.getCurrentUser();
  const accessList = currentUser?.access || [];
debugger;
  const allowedSubMenus = accessList.flatMap(x => x.moduleElements);

  // Loop all menu items
  this.menuItems.forEach((menu: any) => {

    // Reset active state first
    menu.active = false;

    // Check access for main menu
    const hasMainAccess = accessList.some(x => x.moduleName === menu.title);
    menu.hasAccess = hasMainAccess;

    // If clicked top-level menu
    if (menu === clickedItem) {
      menu.active = true;
    }

    // Process children (submenu)
    if (menu.children) {

      menu.children.forEach((child: any) => {

        // Reset active
        child.active = false;

        // Check access for submenu
        child.hasAccess = allowedSubMenus.includes(child.title);

        // If clicked submenu → activate parent + submenu
        if (child === clickedItem) {
          menu.active = true;
          child.active = true;
        }

        // Process sub-submenu (3rd level)
        if (child.children) {
          child.children.forEach((subChild: any) => {
            subChild.active = false;

            // Sub-submenu access (if needed)
            subChild.hasAccess = allowedSubMenus.includes(subChild.title);

            // If clicked → activate parent chain
            if (subChild === clickedItem) {
              menu.active = true;
              child.active = true;
              subChild.active = true;
            }
          });
        }

      });

    }

  });

}


  // Click Toggle menu
  toggletNavActive(item:any) {
    if (!item.active) {
      this.menuItems.forEach((a:any) => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach((b:any) => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
        return
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

  

}
